module.exports = __webpack_public_path__ + "img/orderAccepted.ac7267fe.svg";